<ng-container *ngIf="menu">
  <app-menu-item [item]="menu" [permissions]="permissions"></app-menu-item>
  <span>&nbsp;</span>
</ng-container>
